// Bundled grammar articles — the offline/pre-deploy fallback for the article
// content that normally lives in the `grammar_articles` PocketBase collection.
//
// Vite inlines every markdown file under content/articles at build time via
// import.meta.glob(?raw). We parse the same frontmatter the seed script writes,
// so the local shape matches a PocketBase record exactly (id, slug, title,
// category, content_markdown, difficulty_level, prerequisites_csv). This lets the
// Grammar Map render full CEFR paths even with no backend reachable.
const RAW = import.meta.glob("../../content/articles/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

function parseFrontmatter(raw) {
  const m = raw.match(/^---\s*\n([\s\S]*?)\n---\s*\n?([\s\S]*)$/);
  if (!m) return { meta: {}, body: raw };
  const meta = {};
  for (const line of m[1].split("\n")) {
    const idx = line.indexOf(":");
    if (idx === -1) continue;
    const key = line.slice(0, idx).trim();
    const val = line.slice(idx + 1).trim();
    if (key) meta[key] = val;
  }
  return { meta, body: m[2] };
}

export const LOCAL_ARTICLES = Object.entries(RAW).map(([path, raw]) => {
  const fileSlug = path.split("/").pop().replace(/\.md$/, "");
  const { meta, body } = parseFrontmatter(raw);
  const slug = meta.slug || fileSlug;
  return {
    id: `local:${slug}`,
    slug,
    title: meta.title || fileSlug,
    category: meta.category || "verbs",
    content_markdown: body.trim(),
    difficulty_level: meta.difficulty_level || "A1",
    prerequisites_csv: meta.prerequisites_csv || "",
    _local: true,
  };
});
